import { debounce } from "lodash";
import { useCallback, useState } from "react";

export type IBANDetailsType = {
    valid: boolean;
    messages: string[];
    bankData: {
        bankCode: string;
        name: string;
        bic?: string;
        city?: string;
    };
};

export const useIBANValidation = (
    callbacks: {
        onValid?: (data: IBANDetailsType) => void;
        onInvalid?: (data: IBANDetailsType) => void;
    } = {}
) => {
    const [isLoading, setIsLoading] = useState(false);
    const [ibanDetails, setIbanDetails] = useState<IBANDetailsType>();

    const validate = useCallback(
        debounce((iban) => {
            if (iban) {
                setIsLoading(true);
                fetch(`https://openiban.com/validate/${iban}?getBIC=true`)
                    .then((response) => {
                        if (response.ok) return response.json();
                    })
                    .then((data) => {
                        if (data?.valid === false) callbacks.onInvalid?.(data);
                        if (data?.valid === true) callbacks.onValid?.(data);
                        setIbanDetails(data);
                    })
                    .finally(() => setIsLoading(false));
            }
        }, 350),
        []
    );

    return { validate, ibanDetails, isLoading };
};
